export default __webpack_public_path__ + "static/media/interested-icon.7bb6f767.svg";